import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { observer } from 'mobx-react'

import { observable } from 'mobx'
import Button from '../../shared/components/Button'
import StepNav from '../../shared/components/StepNav'
import Stepper from '../../shared/components/Stepper'
import Form from './Form'
import MuseumDetails from '../../frontend/museum/components/Details'
import Preview from '../../shared/components/Preview'

@observer
class FormPage extends Component {

  static defaultProps = {
    current: {
      address: {}
    }
  }

  static propTypes = {
    canDelete: PropTypes.bool,
    current: PropTypes.object,
    geocoder: PropTypes.shape({
      geocodeAddress: PropTypes.func.isRequired
    }),
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  }

  constructor(props: Object) {
    super(props)
    this.state = {
      section: 'address',
      // eslint-disable-next-line
      formData: {}
    }
  }

  @observable showPreview = false

  @autobind
  handleChangeMultiple(all) {
    this.props.current.set(all)
  }

  @autobind
  handleChange({ target }) {

    let { name } = target
    const { value } = target
    let formData = { [name]: value }

    if (name === 'images') {
      value.forEach((image) => {
        image.pivot = image.pivot || {}
        image.pivot.type = image.type
        image.pivot.description = image.description
        image.banner = image.type === 'banner'
      })
    }

    if (name.indexOf('.') !== -1) {
      const parts = name.split('.')
      name = parts.pop()
      const obj = {}
      const parent = parts.reduce((memo, part) => {
        memo[part] = {}
        return memo[part]
      }, obj)
      parent[name] = value
      formData = obj
    }

    this.props.current.set(formData)

  }

  @autobind
  handleSectionChange({ target }) {
    this.setState({ section: target.value })
  }

  @autobind
  handleDelete(e) {
    e.preventDefault()
    if (this.props.onDelete) {
      this.props.onDelete(this.props.current)
    }
  }

  @autobind
  handleActivate(e) {
    e.preventDefault()
    if (this.props.onActivate) {
      this.props.onActivate(this.props.current)
    }
  }

  @autobind
  handleCancel(e) {
    e.preventDefault()
    if (this.props.onClose) {
      this.props.onClose(this.props.current)
    }
  }

  @autobind
  handleSave(e) {
    e.preventDefault()
    if (this.props.onSave) {
      this.props.onSave(this.props.current)
    }
  }

  @autobind
  handleTogglePreview(e) {
    e.preventDefault()
    this.showPreview = !this.showPreview
  }

  render() {

    const { current, canDelete } = this.props
    const { section } = this.state

    // const validationObj = this.isValid()

    const steps = [
      { key: 'address', title: '1. Anschrift' },
      { key: 'information', title: '2. Informationen' },
      { key: 'visit', title: '3. Besuch' },
      { key: 'equipment', title: '4. Ausstattung' },
      { key: 'media', title: '5. Medien' },
      { key: 'overview', title: '6. Übersicht' },
    ]

    return (
      <div className="museum vertical">

        <Preview
          showPreview={this.showPreview}
          onTogglePreview={this.handleTogglePreview}
          previewComponent={MuseumDetails}
          previewProps={{
            guidedTour: {},
            program: {},
            params: { id: current ? current.id || '-1' : '-1' },
            router: {},
            museum: current || { address: {} }
          }}
          disabled={!current.isValid}
        />

        <form
          className="form form-horizontal vertical"
          onSubmit={this.handleSave}
        >

          <h1>Museumsdaten</h1>

          <StepNav
            active={section}
            onChange={this.handleSectionChange}
            steps={steps}
          />

          {current.isDeactivated
            ? (
              <div className="text-center help-block">
                Dieses Museum ist deaktiviert. Änderungen können erst durchgeführt werden
                nachdem es reaktiviert wurde.
              </div>
            )
            : null}

          <Form
            section={this.state.section}
            current={current}
            validationObj={current.validFields}
            onChange={this.handleChange}
            onChangeMultiple={this.handleChangeMultiple}
            steps={steps}
            goToSection={this.handleSectionChange}
            readOnly={current.isDeactivated}
            geocoder={this.props.geocoder}
          />

          <Stepper
            active={section}
            onChange={this.handleSectionChange}
            steps={steps}
          />

          <div className="form-group">
            <Button
              className="action btn btn-danger pull-left"
              type="button"
              onClick={this.handleDelete}
              disabled={!current.id}
              icon="trash"
              busy={this.props.isBusy}
              confirmation={canDelete
                ? 'Dieses Museum wirklich löschen?'
                : 'Dieses Museum wirklich deaktivieren?'}
            >
              {canDelete ? 'Löschen' : 'Deaktivieren'}
            </Button>

            <Button
              className="btn modal-cancel btn-default"
              type="button"
              onClick={this.handleCancel}
            >
              Abbrechen
            </Button>

            {current.isDeactivated
              ? (
                <Button
                  className="btn action btn-primary pull-right"
                  type="submit"
                  onClick={this.handleActivate}
                  disabled={!current.id}
                  busy={this.props.isBusy}
                  icon="ok"
                  confirmation="Dieses Museum wirklich reaktivieren?"
                >
                  Aktivieren
                </Button>
              )
              : (
                <Button
                  className="action btn btn-primary pull-right"
                  type="submit"
                  onClick={this.handleSave}
                  disabled={!current.isValid}
                  icon="ok"
                  busy={this.props.isBusy}
                >
                  Speichern
                </Button>
              )}

            <Button
              className="btn btn-default pull-right"
              onClick={this.handleTogglePreview}
              disabled={!current.isValid}
              title={current.isValid ? null : 'Vorschau erst möglich, wenn alle Fehler beseitigt wurden'}
            >
              Vorschau
            </Button>

          </div>

        </form>
      </div>
    )
  }
}

export { FormPage as default }



// WEBPACK FOOTER //
// ./src/museum/components/FormPage.js